import { render, staticRenderFns } from "./SiteSection.vue?vue&type=template&id=8fc6f5fc"
import script from "./SiteSection.vue?vue&type=script&lang=js"
export * from "./SiteSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports